import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=6eb27744&scoped=true&class=whform&"
import script from "./page2.vue?vue&type=script&lang=ts&"
export * from "./page2.vue?vue&type=script&lang=ts&"
import style0 from "./page2.vue?vue&type=style&index=0&id=6eb27744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb27744",
  null
  
)

export default component.exports